import jwtDecode from 'jwt-decode';
//import { verify, sign } from 'jsonwebtoken';
//
import axios from '../helper/axiosIntance';

// ----------------------------------------------------------------------

const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }

//   const decoded = jwtDecode(accessToken);
//   const currentTime = Date.now() / 1000;

  //return decoded.exp > currentTime;
  return true;
};

//  const handleTokenExpired = (exp) => {
//   let expiredTimer;

//   window.clearTimeout(expiredTimer);
//   const currentTime = Date.now();
//   const timeLeft = exp * 1000 - currentTime;
//   console.log(timeLeft);
//   expiredTimer = window.setTimeout(() => {
//     console.log('expired');
//     // You can do what ever you want here, like show a notification
//   }, timeLeft);
// };

const setSession = (access_token) => {
  if (access_token) {
    localStorage.setItem('accessToken', access_token);
    //axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    // This function below will handle when token is expired
    // const { exp } = jwtDecode(accessToken);
    // handleTokenExpired(exp);
  } else {
    localStorage.removeItem('accessToken');
   // delete axios.defaults.headers.common.Authorization;
  }
};
const setInfoUser = (user) => {
  if (user) {
    localStorage.setItem('user', user);
    //axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    // This function below will handle when token is expired
    // const { exp } = jwtDecode(accessToken);
    // handleTokenExpired(exp);
  } else {
    localStorage.removeItem('user');
   // delete axios.defaults.headers.common.Authorization;
  }
};

export { isValidToken, setSession,setInfoUser};
